import { isPassedDue } from '../rules/weekLock';

export function assertExportOpen(week, now = Date.now()) {
  if (!Number.isInteger(week) || week < 1 || week > 17 || !isPassedDue(now, week)) throw new Error('Sharing opens Thursday at 7:30 p.m. Chicago time.');
}

export function weeklyFaab({ year, week, names, picks, rankings, winnerData, matchups, challenges, resultsComplete }) {
  const inWeek = row => Number(row.Year) === Number(year) && Number(row.Week) === week;
  const cards = picks.filter(inWeek);
  const votes = rankings.filter(inWeek);
  const pairs = (matchups || []).filter(pair => pair?.length === 2);
  const winners = winnerData?.picks || [];
  const ready = resultsComplete && pairs.length > 0 && pairs.every(pair => pair.filter(t => winners.includes(t[0])).length === 1);
  const prizeReady = ready && Boolean(winnerData?.winner_info?.[0]);
  return names.map(([id, name]) => {
    const entries = cards.filter(p => p.Tid === id);
    const ballot = votes.some(r => r.Tid === id);
    const ownChallenges = challenges?.filter(c => inWeek(c) && c.Tid === id) || [];
    const pending = [];
    if (entries.length > 1) pending.push('Duplicate pick cards need review');
    const card = entries[0];
    const valid = card && pairs.length > 0 && pairs.every(pair => (card.Ids || []).filter(t => pair.some(team => team[0] === t)).length === 1) && card.Ids.length === pairs.length;
    if (card && !valid) pending.push('Pick card needs review');
    if (!ready) pending.push('Matchup results');
    if (cards.length && !prizeReady) pending.push('Weekly winner / tiebreaker');
    let penalty = 0;
    if (card && valid && ready && !card.Ids.some(t => winners.includes(t))) penalty = -5;
    let challenge = 0;
    if (challenges == null) pending.push('Challenge data');
    if (ownChallenges.length > 1) pending.push('Duplicate challenge records need review');
    for (const c of ownChallenges.slice(0, 1)) {
      if (c.Decision !== 'accepted') continue;
      if (c.Outcome === 'completed' && Number.isFinite(Number(c.Faab)) && Number(c.Faab) >= 10 && Number(c.Faab) <= 50) challenge += Number(c.Faab);
      else if (c.Outcome !== 'failed') pending.push('Challenge outcome');
    }
    const prize = prizeReady && winnerData.winner_info[0] === id ? Number(winnerData.winner_info[1]) : 0;
    if (prize && ![5, 10].includes(prize)) pending.push('Winner award needs review');
    const submission = card ? 1 : 0;
    const ranking = ballot ? 1 : 0;
    return { id, name, submission, ranking, prize, penalty, challenge, total: submission + ranking + prize + penalty + challenge, pending, ready: pending.length === 0 };
  });
}

export function rankingRows(votes, names) {
  const totals = new Map();
  votes.forEach(v => (v.Rankings || []).forEach((id, index) => {
    const prev = totals.get(id) || { sum: 0, count: 0 };
    totals.set(id, { sum: prev.sum + index + 1, count: prev.count + 1 });
  }));
  return [...totals].map(([id, v]) => ({ id, name: names.find(n => n[0] === id)?.[1] || id, average: v.sum / v.count, count: v.count })).sort((a, b) => a.average - b.average);
}

export function faabCsv(rows, year, week) {
  const cell = value => typeof value === 'number' ? String(value) : '"' + String(value).replace(/^[=+@-]/, "'").replace(/"/g, '""') + '"';
  return [['Season','Week','Team','Picks','Rankings','Winner','Penalty','Challenge','Calculated adjustment','Status','Credited in Sleeper'], ...rows.map(r => [year, week, r.name, r.submission, r.ranking, r.prize, r.penalty, r.challenge, r.ready ? r.total : '', r.ready ? 'Ready for manual credit' : 'Pending: ' + r.pending.join('; '), 'Not recorded'])].map(row => row.map(cell).join(',')).join('\r\n');
}
